export type SaveBody = Record<string, unknown>
export type SaveChoice = 'local' | 'server'

// JSON 요청의 의미를 비교한다. 속성 순서와 전송되지 않는 undefined는 변경으로 세지 않는다.
function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical)
  if (value && typeof value === 'object')
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, item]) => item !== undefined)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([key, item]) => [key, canonical(item)])
    )
  return value
}
export const sameSaveValue = (a: unknown, b: unknown) =>
  JSON.stringify(canonical(a)) === JSON.stringify(canonical(b))

/** 배열·구조화된 항목은 하나의 편집 단위로 취급한다. 기준본이 없으면 다른 값은 반드시 선택받는다. */
export function compareSaveBodies(
  base: SaveBody | undefined,
  local: SaveBody,
  server: SaveBody
) {
  const merged = { ...server }
  const conflicts: string[] = []
  for (const key of new Set([...Object.keys(local), ...Object.keys(server)])) {
    if (sameSaveValue(local[key], server[key])) continue
    if (base && sameSaveValue(local[key], base[key])) continue
    if (base && sameSaveValue(server[key], base[key])) merged[key] = local[key]
    else conflicts.push(key)
  }
  return { merged, conflicts }
}
